import React, { useEffect, useRef, useState } from "react";
import PageTitleBanner from "../../Components/Reusable/PageTitleBanner";
import Image from "../../Components/Reusable/Image";
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import { Link, useParams } from "react-router-dom";
import ApiService from "../../Services/ApiService";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation"; // Import Swiper styles for navigation
import { Pagination, Navigation } from "swiper/modules";
import imageone from "../../assets/images/png/mainimageblog.png";
import { handleApiErrors, htmlToText } from "../../Utils/Utils";
import ApiConstants from "../../Utils/ApiConstant";
import RoutesPath from "../../Utils/RoutesPath";
import parse from "html-react-parser";
import ShareButtons from "../SocialShare";
import CustomNavigation from "../../Components/Reusable/CustomNavigation";
import "swiper/css/bundle";
import { Autoplay, FreeMode } from "swiper/modules";
import "swiper/css/free-mode";
import dayjs from "dayjs";
import { Helmet } from "react-helmet";
let filteredBlogData = []
const BlogDetails = () => {
  const [socialMediaLinks, setSocialMediaLinks] = useState();
  const swiperRef = useRef(null); // Ref to hold the Swiper instance
  const [blogData, setBlogData] = useState([filteredBlogData]);
  const [blogDataId, setBlogDataId] = useState([]);
  const [blogCategories, setBlogCategories] = useState([]);
  const [authors, setAuthors] = useState([]);
  const { categoryId, blogId } = useParams();
  const [offset, setOffset] = useState(0);
  const [limit] = useState(9);

  // const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  const getSocialContactInfo = async () => {
    try {
      const response = await ApiService.getSocialContactInfo();
      setSocialMediaLinks(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  };

  // const getBlogcategory = async () => {
  //   try {
  //     const response = await ApiService.getBlogcategory();
  //     setBlogCategories(response.blogCategory ?? []);
  //   } catch (error) {
  //     console.error("Error fetching Blog categories:", error);
  //   }
  // };
  // const getBlogdata = async (categoryId) => {
  //   try {
  //     const response = await ApiService.getBlogdata(categoryId, limit, offset);
  //     setBlogCategories(response.data.blogCategoryData ?? []);
  //     setBlogData(response.data.BlogData ?? []);
  //     setAvailableDataCount(response.availableDataCount);
  //   } catch (error) {
  //     handleApiErrors(error);
  //   }
  // };
  const getBlogDetailById = async (blogId) => {
    try {
      const response = await ApiService.getBlogDetailById(blogId);
      setBlogDataId(response.data.blogCategoryData);
      setBlogData(response.data.relatedBlogs ?? []);
      setAvailableDataCount(response.availableDataCount);
    } catch (error) {
      handleApiErrors(error);
    }
  };
  // useEffect(() => {
  //   if (categoryId !== null) {
  //     getBlogdata(categoryId);
  //   }
  // }, [categoryId, offset]);

  useEffect(() => {
    if (blogId !== null) {
      getBlogDetailById(blogId);
    }
  }, [blogId, offset]);
  useEffect(() => {
    getAllAuthers();
    // getBlogcategory();
  }, []);
  useEffect(() => {
    getBlogDetailById(blogId);
    getSocialContactInfo();
  }, [blogId]);
  const getAllAuthers = async () => {
    try {
      const response = await ApiService.getAllAuthers();
      setAuthors(response.authorData);
    } catch (error) {
      handleApiErrors(error);
    }
  };
  const findAuthorNameById = (authorId) => {
    const author = authors.find((author) => author.author_id === authorId);
    return author ? author.name : "Unknown Author";
  };
  const Blogdetails = blogData.length > 0 ? blogData[0] : null;

  const breadcrumbItems = [
    { currentTitle: "Blog", path: RoutesPath.blog },
    { currentTitle: blogDataId ? blogDataId.title : "", path: null }, // Add path as needed
  ];

  // const customParser = (node) => {
  //   if (node.name === "oembed") {
  //     const url = node.attribs.url;
  //     if (url && url.includes("youtu")) {
  //       const videoId = new URL(url).searchParams.get("v");
  //       return (
  //         <iframe
  //           width="560"
  //           height="315"
  //           src={`https://www.youtube.com/embed/${videoId}`}
  //           frameBorder="0"
  //           allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  //           allowFullScreen
  //           title="YouTube video"
  //         />
  //       );
  //     }
  //   }
  // };

  const customParser = (node) => {
    if (node.name === "oembed") {
      const url = node.attribs.url;
      let videoId;
      // Handle both normal YouTube URLs (youtube.com) and short URLs (youtu.be)
      if (url.includes("youtube.com")) {
        videoId = new URL(url).searchParams.get("v");  // Extract the video ID from the "v" parameter
      } else if (url.includes("youtu.be")) {
        videoId = url.split("/").pop().split("?")[0];  // Extract the ID after the last "/"
      }
      if (videoId) {
        return (
          <iframe
            width="560"
            height="315"
            src={`https://www.youtube.com/embed/${videoId}`}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="YouTube video"
          />
        );
      } else {
        return <p className='text-danger'>Invalid YouTube URL</p>;
      }
    }
  };
  filteredBlogData = blogData.filter(
    (blog) => blog.blog_id !== blogDataId._id
  );
  return (
    <div className="d-flex flex-column mb-auto">
      <Helmet>
        <title>{blogDataId.blogSEO?.metaTitle || "Learn and Achieve"}</title>
        <meta name="description" content={blogDataId.blogSEO?.metaDescription || "Default description"} />
        <meta name="keywords" content={blogDataId.blogSEO?.metaKeywords || "keywords"} />
        <meta property="og:title" content={blogDataId.blogSEO?.metaTitle || "Learn and Achieve"} />
        <meta property="og:description" content={blogDataId.blogSEO?.metaDescription || "description"} />
        <meta property="og:image" content={ApiConstants.FILE_FETCH_URL + (blogDataId.blogSEO?.altTagFeaturedImage || "default-image.jpg")} />
        <meta property="og:url" content={blogDataId.blogSEO?.url ||  window.location.href} />
        <link rel="canonical" href={blogDataId.blogSEO?.canonicalURL || window.location.href} />
      </Helmet>
      {blogDataId && (
        <PageTitleBanner PageTitle={"Blog"} currentTitle={breadcrumbItems} />
      )}
      <div className="text-content-page-container d-flex flex-column align-items-center">
        <div className="d-flex flex-column gap-3 align-items-start container p-0">
          <>
            <h2 className="Heading darkBlueColor mb-0 fw-600 text-capitalize">
              {blogDataId.title}
            </h2>
            <div className="d-flex gap-3 flex-wrap">
              {blogCategories.map((category) => {
                if (category.blog_category_id === blogDataId.category_id) {
                  return (
                    <div
                      key={category.category_id}
                      className="medium-text fw-600 orangeAccentColor categoryborder"
                    >
                      {category.categoryName}
                    </div>
                  );
                }
                return null;
              })}

              <div className="d-flex gap-3">
                <div className="d-flex gap-2 align-items-center">
                  <Image src={PngImages.bloguser} />
                  <h3 className="small-text fw-400 mb-0 author">
                    {findAuthorNameById(blogDataId.author_id)}
                  </h3>
                </div>
                <div className="d-flex gap-2 align-items-center">
                  <Image src={PngImages.blogcalender} />
                  <h3 className="small-text fw-400 mb-0 author">
                    {" "}
                    {new Date(blogDataId.date).toLocaleDateString()}
                  </h3>
                </div>
              </div>
            </div>
            <div className="w-100 blog-data-html" style={{ contain: "content" }}>
              {blogDataId?.details &&
                parse(blogDataId.details, { replace: customParser })}
            </div>
          </>
          {/* ))} */}
          <div className="d-flex w-100 flex-column gap-3 align-items-center justify-content-center  mt-2">
            <h3 className="medium-text fw-500 mb-0 black">
              Don't Forget to Share this Post!
            </h3>
            <div className="d-flex flex-wrap gap-2 mt-0 ">
              <ShareButtons
                socialMediaLinks={socialMediaLinks}
                blogDataId={blogDataId}
              />
            </div>
          </div>
        </div>
      </div>
      {filteredBlogData && filteredBlogData.length > 0 ? (
        <div className="blogswiperbgcolor ">
          <div className="d-flex container flex-column justify-content-start position-relative">
            <h2 className="Heading headingColor mb-0 fw-600 py-4 px-0">
              Related Blogs
            </h2>
            <div className="">
              <Swiper
                slidesPerView={5}
                spaceBetween={20}
                centeredSlides={true}
                autoplayspeed={500}
                autoplay={true}
                freeMode={true}
                loop={false}
                ref={swiperRef}
                navigation={{
                  nextEl: ".next-button",
                  prevEl: ".prev-button",
                }}
                pagination={{
                  clickable: true,
                  bulletActiveClass: "swiperActiveBullet",
                }}
                breakpoints={{
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                  },
                  992: {
                    slidesPerView: 3,
                    autoplay: true,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                    autoplay: true,
                  },
                  576: {
                    slidesPerView: 2,
                    centeredSlides: true,
                  },
                  425: {
                    centeredSlides: true,
                    slidesPerView: 1,
                    autoplay: true,
                  },
                  0: {
                    centeredSlides: true,
                    slidesPerView: 1,
                    autoplay: true,
                    pagination: false,
                  },
                }}
                modules={[FreeMode, Autoplay, Navigation, Pagination]}
                className="mb-3 container pb-5"
              >
                {filteredBlogData.map((card, index) => (
                  <SwiperSlide key={index}>
                    <BlogCard {...card} />
                  </SwiperSlide>
                ))}
              </Swiper>
              <CustomNavigation swiperInstance={swiperRef.current} />
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};
const BlogCard = ({
  featuredImage,
  title,
  briefIntro,
  author_id,
  date,
  blog_id,
  category_id,
}) => {
  const [authors, setAuthors] = useState([]);
  useEffect(() => {
    getAllAuthers();
  }, []);
  const getAllAuthers = async () => {
    try {
      const response = await ApiService.getAllAuthers();
      setAuthors(response.authorData);
    } catch (error) {
      handleApiErrors(error);
    }
  };
  const findAuthorNameById = (authorId) => {
    const author = authors.find((author) => author.author_id === authorId);
    return author ? author.name : "Unknown Author";
  };

  return (
    <div className=" mb-4 BlogMobileresponsive d-flex justify-content-center">
      <div className="card h-100 BlogDetailcards Blogcardimage">
        <div className="blogcardimagesize">
          <Image
            src={
              featuredImage
                ? ApiConstants.FILE_FETCH_URL + featuredImage
                : PngImages.blogdetailimage
            }
            className="card-img-top Blogcardimage"
            alt="..."
          />
        </div>
        <div
          className="card-body d-flex flex-column gap-3"
          style={{ overflow: "hidden" }}
        >
          <div className="d-flex gap-3">
            <div className="d-flex gap-2 align-items-center">
              <Image src={PngImages.bloguser} />
              <h3 className="small-text fw-400 mb-0 author">
                {findAuthorNameById(author_id)}
              </h3>
            </div>
            <div className="d-flex gap-2 align-items-center">
              <Image src={PngImages.blogcalender} />
              <h3 className="small-text fw-400 mb-0 author">{dayjs(date).format("DD / MM / YYYY")}</h3>
            </div>
          </div>
          <div style={{ height: "105px" }}>
            <h5 className="card-title large-text fw-600 darkBlueColor Blogtexting mb-1 text-capitalize">
              {title}
            </h5>
            <p className="card-text medium-text fw-400 Blogtexting">
              {briefIntro}
            </p>
          </div>
          <div className="d-flex justify-content-end">
            <div className="d-flex align-items-center gap-2">
              <Link to={`${RoutesPath.blogdetails}/${blog_id}`}>
                <h3 className="medium-text fw-500 mb-0 black">Read more</h3>
              </Link>
              <Image src={SvgImages.blogrightarrow} style={{ marginTop: 2 }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetails;
